import { render } from "./user-four.vue?vue&type=template&id=0a66a14c"
import script from "./user-four.vue?vue&type=script&lang=js"
export * from "./user-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__